// таблица цветов
export const lineColors = {
  purple: '#860086ff',
  orange: '#a57900ff',
  orange2: '#a57900ff',
  orange3: '#a57900ff',
  black: '#000000',
  green: '#00722cff',
  red: '#ac0101ff',
  red2: '#007e8fff',
  blue: '#0021dfff',   
  blue2: '#0021dfff', 
};

// объект для хранения количества пар
const pairStats = {
  "4-4": 0,
  "3-4": 0,
  "3-3": 0,
  "2-3": 0,
  "2-2": 0,
  "1-1": 0,
  "1-2": 0,
  "1-3": 0,
  other: 0
};

export function getColor(rank1, rank2) {
  let pairKey = `${rank1}-${rank2}`;

  // чтобы 3-4 и 4-3 считались одинаково
  if (rank1 > rank2) {
    pairKey = `${rank2}-${rank1}`;
  }

  // считаем статистику
  if (pairStats[pairKey] !== undefined) {
    pairStats[pairKey]++;
  } else {
    pairStats.other++;
  }

  // возвращаем цвет
  if (pairKey === "4-4") {
    return "purple";
  } else if (pairKey === "3-4") {
    return "green";
  } else if (pairKey === "3-3") {
    return "red";
  } else if (pairKey === "2-3") {
    return "blue2";
  } else if (pairKey === "2-2") {
    return "orange2";
  } else if (pairKey === "1-2") {
    return "orange";
  } else if (pairKey === "1-1") {
    return "orange3";
  } else if (pairKey === "1-3") {
    return "blue";
  } else {
    return "black";
  }
}

// 👉 получить статистику
export function getPairStats() {
  return pairStats;
}



// формируется топология оборудования
export function calculateLines(switches) {
  console.log(switches)
   // Сбрасываем статистику
  for (const key in pairStats) {
    pairStats[key] = 0;
  }
  const lines = [];
  for (let i = 0; i < switches.length; i++) {
    const currentCoordinate = switches[i];
    if (currentCoordinate.dest_ip && currentCoordinate.dest_ip.length > 0) {
      for (let j = 0; j < currentCoordinate.dest_ip.length; j++) {
        const destIp = currentCoordinate.dest_ip[j];
        const matchingCoordinates = switches.filter(coord => coord.ip === destIp);
        for (let k = 0; k < matchingCoordinates.length; k++) {
          const destCoordinate = matchingCoordinates[k];
          const lineColor = getColor(currentCoordinate.rank, destCoordinate.rank);
          lines.push({
            positions: [[currentCoordinate.latitude, currentCoordinate.longitude], [destCoordinate.latitude, destCoordinate.longitude]],
            color: lineColor
          });
        }
      }
    }
  }
  
  return lines;
}

